/* YeahOneStyle v3 — vanilla only, no libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header: transparent over the hero, solid + fixed once scrolled */
  var hd = document.querySelector('[data-hd]');
  if (hd) {
    var over = hd.getAttribute('data-over') === '1';
    var stuck = null;
    var tick = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var s = y > 40;
      if (s !== stuck) {
        stuck = s;
        hd.classList.toggle('hd--stuck', s);
        if (over) hd.classList.toggle('hd--onMedia', !s);
      }
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* hero film — built in JS and swapped in after load.
     The still image is the only hero element in the HTML: anything stacked over it
     (a <video>, even at opacity 0) stopped Chrome from using it as the LCP element. */
  var media = document.querySelector('[data-hero-media]');
  if (media && !reduce) {
    var startFilm = function () {
      var small = window.matchMedia('(max-width: 900px)').matches;
      var src = small ? media.getAttribute('data-src-mob') : media.getAttribute('data-src-desk');
      if (!src) return;

      var still = media.querySelector('.hero__poster');
      var film = document.createElement('video');
      film.muted = true;                 /* iOS wants these as properties too */
      film.loop = true;
      film.autoplay = true;
      film.preload = 'auto';
      film.setAttribute('muted', '');
      film.setAttribute('playsinline', '');
      film.setAttribute('aria-hidden', 'true');

      var swap = function () {
        film.classList.add('is-on');
        if (!still) return;
        var drop = function () { if (still.parentNode) still.parentNode.removeChild(still); };
        if (still.decode) still.decode().then(drop, drop); else drop();
      };
      film.addEventListener('canplay', swap, { once: true });

      film.src = src;
      media.appendChild(film);
      var p = film.play();
      if (p && p.catch) p.catch(function () {});
      film.addEventListener('loadedmetadata', function () {
        var q = film.play();
        if (q && q.catch) q.catch(function () {});
      }, { once: true });
    };

    /* 3–5 MB of video would compete with the poster for bandwidth. */
    var laterFilm = function () { setTimeout(startFilm, 300); };
    if (document.readyState === 'complete') laterFilm();
    else window.addEventListener('load', laterFilm, { once: true });
  }

  /* reveal on enter */
  var rv = document.querySelectorAll('.rv');
  if (rv.length && !reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }

  /* inches computed from stored centimetres (cm / 2.54, 2 dp) */
  document.querySelectorAll('[data-cm]').forEach(function (el) {
    var cm = parseFloat(el.getAttribute('data-cm'));
    if (!isNaN(cm)) el.textContent = (cm / 2.54).toFixed(2);
  });

  /* PDP: variant picking keeps image / tag / price / sizes in sync */
  var picker = document.querySelector('[data-picker]');
  if (picker) {
    var data = JSON.parse(picker.getAttribute('data-variants') || '[]');
    var mainImg = document.querySelector('[data-main-img]');
    var tag = document.querySelector('[data-tag]');
    var priceEl = document.querySelector('[data-price]');
    var cmpEl = document.querySelector('[data-compare]');
    var saleEl = document.querySelector('[data-sale]');
    var idIn = document.querySelector('[name="id"]');
    var curColorEl = document.querySelector('[data-color-name]');

    function byId(id) {
      return data.filter(function (x) { return String(x.id) === String(id); })[0];
    }
    function render(id) {
      var v = byId(id);
      if (!v) return;
      if (idIn) idIn.value = v.id;
      if (mainImg && v.image) mainImg.src = v.image;
      if (tag && v.color) tag.textContent = v.color;
      if (curColorEl && v.color) curColorEl.textContent = v.color;
      if (priceEl) priceEl.textContent = v.price;
      if (cmpEl) { cmpEl.textContent = v.compare || ''; cmpEl.hidden = !v.compare; }
      if (saleEl) saleEl.hidden = !v.compare;
      document.querySelectorAll('[data-size]').forEach(function (b) {
        var m = data.filter(function (x) {
          return x.size === b.getAttribute('data-size') && x.color === v.color;
        })[0];
        b.setAttribute('aria-disabled', (!m || !m.available) ? 'true' : 'false');
        b.classList.toggle('is-on', !!m && String(m.id) === String(v.id));
      });
      document.querySelectorAll('[data-color]').forEach(function (s) {
        s.classList.toggle('is-on', s.getAttribute('data-color') === v.color);
      });
    }

    picker.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-size],[data-color]');
      if (!t) return;
      var size = t.getAttribute('data-size');
      var col = t.getAttribute('data-color');
      var now = byId(idIn ? idIn.value : '');
      var wantCol = col || (now && now.color);
      var wantSize = size || (now && now.size);
      var next = data.filter(function (x) { return x.color === wantCol && x.size === wantSize; })[0];
      if (next && next.available) render(next.id);
      else if (col) {
        var alt = data.filter(function (x) { return x.color === col && x.available; })[0];
        if (alt) render(alt.id);
      }
    });

    if (idIn && idIn.value) render(idIn.value);
  }

  /* gallery thumbs — click (or Enter) swaps the main image */
  var gallery = document.querySelector('[data-pdp-gallery]');
  if (gallery) {
    var big = gallery.querySelector('[data-main-img]');

    /* warm the other frames once the page is idle, so a click is instant instead
       of starting a fresh CDN request every time */
    var warm = function () {
      gallery.querySelectorAll('.pdp__thumb').forEach(function (t) {
        var u = t.getAttribute('data-full');
        if (u && (!big || u !== big.getAttribute('src'))) {
          var im = new Image();
          im.decoding = 'async';
          im.src = u;
        }
      });
    };
    /* warm the other frames as soon as the first one is in, so a click is instant */
    if (big && !big.complete) {
      big.addEventListener('load', function () { setTimeout(warm, 120); }, { once: true });
    } else {
      setTimeout(warm, 120);
    }

    gallery.querySelectorAll('.pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        gallery.querySelectorAll('.pdp__thumb').forEach(function (x) {
          x.classList.remove('is-on');
          x.setAttribute('aria-current', 'false');
        });
        t.classList.add('is-on');
        t.setAttribute('aria-current', 'true');
        if (big) {
          var full = t.getAttribute('data-full') || t.getAttribute('src');
          if (full && full !== big.getAttribute('src')) big.src = full;
        }
      });
      t.setAttribute('tabindex', '0');
      t.setAttribute('role', 'button');
      t.setAttribute('aria-current', t.classList.contains('is-on') ? 'true' : 'false');
      t.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); t.click(); }
      });
    });
  }

  /* cart — qty stepper + line removal via /cart/change.js, then a soft reload */
  var cartRoot = document.querySelector('[data-cart]');
  if (cartRoot) {
    var change = function (key, qty, line) {
      line.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        line.classList.remove('is-busy');
        window.location.reload();
      });
    };

    cartRoot.addEventListener('click', function (ev) {
      var minus = ev.target.closest('[data-qty]');
      var rm = ev.target.closest('[data-remove]');
      if (minus) {
        var line = minus.closest('[data-line]');
        var shown = parseInt((line.querySelector('.qty span') || {}).textContent || '0', 10);
        var next = shown + parseInt(minus.getAttribute('data-qty'), 10);
        change(minus.getAttribute('data-key'), Math.max(0, next), line);
        return;
      }
      if (rm) {
        var l = rm.closest('[data-line]');
        change(rm.getAttribute('data-key'), 0, l);
      }
    });
  }

  /* add to bag */
  var form = document.querySelector('[data-form]');
  if (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('[data-add]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('unavailable');
        return r.json();
      }).then(function () {
        if (btn) btn.textContent = 'ADDED';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-bag]').forEach(function (el) { el.textContent = c.item_count; });
        });
        setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1400);
      }).catch(function () {
        /* sold out or network — say something instead of silently resetting */
        if (btn) {
          btn.textContent = 'UNAVAILABLE — TRY ANOTHER SIZE';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
        }
      });
    });
  }

  /* sale countdown — only ticks if the page has one */
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var end = Date.parse(cd.getAttribute('data-countdown'));
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var put = function (sel, v) { var el = cd.querySelector(sel); if (el) el.textContent = pad(v); };
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      put('[data-d]', Math.floor(left / 864e5));
      put('[data-h]', Math.floor(left % 864e5 / 36e5));
      put('[data-m]', Math.floor(left % 36e5 / 6e4));
      put('[data-s]', Math.floor(left % 6e4 / 1e3));
      if (left === 0) cd.classList.add('is-over');
    };
    if (!isNaN(end)) { tick(); setInterval(tick, 1000); }
  }
})();
